// IMPORTANT NOTE:
// These files are also present in FEA until blu_constants is rolled out
// if you change anything here, you need to change it there as well.

import BlumiraAgent from "./blumira_agent";
import AutoIsolation from "./auto_isolation";

export default {
  LOGSHIPPING: BlumiraAgent,
  AUTOBOT: AutoIsolation,
};
